import React, { useContext, useEffect, useState } from "react";
import { Container } from "semantic-ui-react";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import { observer } from "mobx-react-lite";
import oneOrderStore from "../../../../app/stores/oneOrderStore";

interface IProps {}

const WorkOrderSORSGrid: React.FC<IProps> = () => {
  const workorderStore = useContext(oneOrderStore);
  const { selectedWorkOrderSors: workorderSors } = workorderStore;
  const [sorList, setSorList] = useState([{}]);
  const { selectedWorkOrder: workorder } = workorderStore;

  useEffect(() => {
    if (workorder != null) {
      setSorList(workorderSors);
    }
  }, [workorderSors,workorder]);

  return (
    <Container>
      <div
        className="ag-theme-material"
        style={{ height: "200px", width: "100%" }}
      >
        <AgGridReact
          enableColResize={true}
          enableSorting={true}
          colResizeDefault={true}
          columnDefs={SorCols}
          rowData={sorList}
          tooltipShowDelay={0} // Optional: Delay in showing tooltips (in ms)
          tooltipHideDelay={2000} // Optional: Delay in hiding tooltips (in ms)
        />
      </div>
    </Container>
  );
};

const SorCols = [
  {
    headerName: "Description",
    field: "SORDescripion",
    width: 420,
    tooltipField: "SORDescripion", // Enable tooltip for this field
  },
  { 
    headerName: "Desc", 
    field: "LongDesc", 
    tooltipField: "LongDesc", // Enable tooltip for this field
  },
  { 
    headerName: "Qty", 
    field: "SORQty", 
    width: 100,
    tooltipField: "SORQty", // Enable tooltip for this field
  },
  { 
    headerName: "SOR", 
    field: "SORCode", 
    width: 100,
    tooltipField: "SORCode", // Enable tooltip for this field
  },
 
  {
    headerName: "Value",
    field: "SORValue",
    width: 150,
    tooltipField: "SORValue", // Enable tooltip for this field
  }
];





export default observer(WorkOrderSORSGrid);
